<template>
	<div class="wrapper">
		<el-tabs type="border-card" class="meeting-list" v-model="activeName" @tab-click="toggleSwitch">
			<div class="meeting-search-text">
				会议列表
			</div>
			<el-tab-pane label="未开始" name="first">
				<div class="meeting-search">
					<el-form :inline="true" :model="meetingForm" class="demo-form-inline">
						<div class="flex align-center justify-between">
							<div class="flex align-center searchs">
								<el-form-item label="案号" style="margin-right: 50px">
									<el-input @change="monitor" v-model.trim="meetingForm.subject" clearable
										placeholder="请输入案号"></el-input>
								</el-form-item>
								<el-form-item label="会议名称" style="margin-right: 50px">
									<el-input @change="monitor" v-model.trim="meetingForm.name" clearable
										placeholder="请输入会议名称"></el-input>
								</el-form-item>
								<!-- el-form-right-1 -->
								<el-form-item class="">
									<!--  style="background: #de4d2a !important" -->
									<el-button type="primary" icon="el-icon-search" style="margin-right: 5px;"
										@click="onSubmit">查询
									</el-button>
								</el-form-item>
								<el-form-item class="">
									<!-- style="background: #de4d2a !important" -->
								
									<el-button style="background-color: #F2F3F7;margin-right: 5px;"
										icon="el-icon-zhongzhishaixuan" :style="resetStyle()" :disabled="resetDisabled"
										@click="reset()">重置</el-button>
								</el-form-item>
							</div>
							<div class="flex align-center">
								<!-- el-form-right-2 -->
								
								<el-form-item class="">
									<!-- style="background: #de4d2a !important" -->
									<el-button @click="addCreateMeeting" icon="el-icon-plus"
										style="border: 1px solid #9BA2AB;color: #282D30;">
										新建会议</el-button>
								</el-form-item>
							</div>
						</div>


					</el-form>
				</div>
				<el-row class="table-meeing" :gutter="24">
					<!-- {{tableData}} -->
					<el-table align="center" ref="multipleTable" :data="tableData" size="medium" height="64.6vh"
						v-loading="loading" @selection-change="handleSelectionChange">
						<el-table-column align="center" type="selection" width="50"> </el-table-column>
						<el-table-column align="center" prop="subject" label="案号"></el-table-column>
						<el-table-column align="center" prop="name" label="会议名称"> </el-table-column>
						<el-table-column align="center" prop="startTime" label="会议日期">
							<template slot-scope="scope">
								{{ timeConvert(scope.row.startTime) }}
							</template>
						</el-table-column>
						<el-table-column align="center" prop="sponsor" label="发起人"> </el-table-column>
						<el-table-column align="center" prop="participantNum" label="参会人数">
							<template slot-scope="scope">
								{{ scope.row.participantNum ? scope.row.participantNum : 0 }}
							</template>
						</el-table-column>
						<el-table-column align="center" label="操作列" width="250">
							<template slot-scope="scope">
								<div class="operations">
									<div class="">
										<!-- <el-button size="mini" type="text" @click="editMeeting(scope.row)">编辑会议
										</el-button> -->
										<!-- @click="enterMeeting(scope.row)" -->
										<!-- openPersonManagers(scope.row.id, scope.row.name, 0, 'first',scope.row) -->
										<!-- <el-button size="mini" type="text" @click="enterMeeting(scope.row)">进入会议
										</el-button> -->
										
										<el-button size="medium" type="text"
											@click="openPersonManagers(scope.row.id, scope.row.name, 0, 'first',scope.row)">
											进入会议
										</el-button>
										<router-link :to="{
										    path: '/liveBroadcast',
										    query: { id: scope.row.id, name: scope.row.name,tab:'first' }
										}">会议直播</router-link>
										<el-tooltip class="item" effect="dark" content="编辑会议" placement="top">
											<div class="el-icon-edit-outline" style="font-size: 16px;color: #2766FF;margin-right: 5px;margin-left: 5px;"
												@click="editMeeting(scope.row)">

											</div>
										</el-tooltip>
										<!-- :tabindex="Number(scope.row.index)" trigger="click" @command="getList()" @visible-change="visibleChanges(scope.row.index)" -->
										<!-- @click="removeImage(scope.row.index)" -->
										<!-- <div class="select"> -->
											<el-dropdown trigger="click">
												<!-- 更多操作 -->
												<!-- :class="scope.row.visibleChange?'visibleChange':''" -->
												<span class="el-dropdown-link">
													<el-icon style="font-size: 16px;"
														class="el-icon-arrow-down el-icon--right">
														<arrow-down />
													</el-icon>
													<!-- <i class="el-icon-arrow-down el-icon--right"
														style="font-size: 14px;"
														><arrow-down /></i> -->

												</span>
												<template #dropdown>
													<el-dropdown-menu slot="dropdown">

														<el-dropdown-item class="">
															<el-button icon="el-icon-a-ceshihuiyi1x" size="medium" type="text"
																@click="testMeeting(scope.row.id, 'start')">
																测试会议
															</el-button>
														</el-dropdown-item>
														<el-dropdown-item class="el-droplink">
															<el-button icon="el-icon-kaishi" size="medium" type="text"
																@click="beginMeeting(scope.row.id)">开始会议
															</el-button>
														</el-dropdown-item>
														<!-- <el-dropdown-item class="el-droplink">
															<el-button  icon="el-icon-renyuan" size="medium" type="text"
																style="color: #282D30;"
																@click="openPersonManager(scope.row.id, scope.row.name, 0, 'first')">人员管理</el-button>
														</el-dropdown-item> -->
														<el-dropdown-item class="el-droplink">
															<el-button icon="el-icon-peizhi" size="medium" type="text"
																@click="meetingConfig(scope.row)">视频配置
															</el-button>
														</el-dropdown-item>
														<el-dropdown-item>
															<el-button icon="el-icon-shanchu1" size="medium" type="text"
																@click="deleteMeeting(scope.row.id)">删除会议
															</el-button>
														</el-dropdown-item>
													</el-dropdown-menu>
													</template>
											</el-dropdown>
										<!-- </div> -->

									</div>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</el-row>
				<el-row :gutter="24">
					<Pagination :total="total" @handleSizeChange="turnPage" @handleCurrentChange="turnPage">
						<template v-slot:operation>
							<div style="padding-left: 25px">
								<el-button @click="deleteAll()">批量删除</el-button>
								<el-button @click="toggleSelection">取消选择</el-button>
							</div>
						</template>
					</Pagination>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="进行中" name="second">
				<div class="meeting-search">
					<el-form :inline="true" :model="meetingForm" class="demo-form-inline">
						<div class="flex align-center justify-between">
							<div class="flex align-center searchs">
								<el-form-item label="案号" style="margin-right: 50px">
									<el-input @change="monitor" v-model.trim="meetingForm.subject" clearable placeholder="请输入案号">
									</el-input>
								</el-form-item>
								<el-form-item label="会议名称" style="margin-right: 50px">
									<el-input @change="monitor" v-model.trim="meetingForm.name" clearable placeholder="请输入会议名称">
									</el-input>
								</el-form-item>
								<el-form-item class="">
									<el-button style="margin-right: 5px;" type="primary" icon="el-icon-search" @click="onSubmit">查询
									</el-button>
									<el-button style="background-color: #F2F3F7;"
										icon="el-icon-zhongzhishaixuan" :style="resetStyle()" :disabled="resetDisabled"
										@click="reset()">重置</el-button>
									<!-- style="background: #de4d2a !important"  -->
									
								</el-form-item>
							</div>
							<!-- el-form-right-1 -->
							<!-- <div class="flex align-center">
								
								
							</div> -->
						</div>
					</el-form>
				</div>
				<el-row class="table-meeing" :gutter="24">
					<el-table :data="tableData" size="medium" height="64.6vh" v-loading="loading"
						@selection-change="handleSelectionChange">
						<!-- <el-table-column type="selection" width="50"> </el-table-column> -->
						<el-table-column align="center" prop="subject" label="案号"></el-table-column>
						<el-table-column align="center" prop="name" label="会议名称"> </el-table-column>
						<el-table-column align="center" prop="startTime" label="会议日期">
							<template slot-scope="scope">
								{{ timeConvert(scope.row.startTime) }}
							</template>
						</el-table-column>
						<el-table-column align="center" prop="sponsor" label="发起人"> </el-table-column>
						<el-table-column align="center" prop="participantNum" label="参会人数">
							<template slot-scope="scope">
								{{ scope.row.participantNum ? scope.row.participantNum : 0 }}
							</template>
						</el-table-column>
						<el-table-column align="center" label="操作列" width="250">
							<template slot-scope="scope">
								<div class="operations">
									<div>
										<!-- enterMeeting(scope.row) -->
										<!-- openPersonManagers(scope.row.id, scope.row.name, 0, '',scope.row)" -->
										<el-button size="medium" type="text"
											@click="openPersonManagers(scope.row.id, scope.row.name, 0, 'second',scope.row)">
											进入会议
										</el-button>

										<router-link :to="{
										    path: '/liveBroadcast',
										    query: { id: scope.row.id, name: scope.row.name,tab:'second' }
										}">会议直播</router-link>
										<el-tooltip class="item" effect="dark" content="视频配置" placement="top">
											<div class="el-icon-peizhi" style="font-size: 16px;color: #2766FF;margin-right: 5px;margin-left: 5px;"
												@click="meetingConfig(scope.row)">
										
											</div>
										</el-tooltip>
										
										<el-tooltip class="item" effect="dark" content="结束会议" placement="top">
											<div class="el-icon-zhongzhi" style="font-size: 16px;color: #2766FF;margin-right: 5px;margin-left: 5px;"
												@click="endMeeting(scope.row.id)">

											</div>
										</el-tooltip>
										
										<!-- <el-button size="mini" type="text" @click="endMeeting(scope.row.id)"></el-button> -->
										<!-- <el-dropdown trigger="click">
											<span class="el-dropdown-link">

												<i class="el-icon-arrow-down el-icon--right" style="font-size: 16px;"></i> </span>
											<el-dropdown-menu slot="dropdown">

												<el-dropdown-item class="el-droplink">
													<el-button style="color: #282D30;" icon="el-icon-renyuan" size="medium" type="text"
														@click="openPersonManager(scope.row.id, scope.row.name, 1, 'second')">人员管理</el-button>
												</el-dropdown-item>
												<el-dropdown-item class="el-droplink">
													<el-button style="color: #282D30;" icon="el-icon-peizhi" size="medium" type="text"
														@click="meetingConfig(scope.row)">视频配置
													</el-button>
												</el-dropdown-item>
											</el-dropdown-menu>
										</el-dropdown> -->
									</div>
									<div>
										<!-- <el-button size="mini" type="text"
											@click="openPersonManager(scope.row.id, scope.row.name, 1, 'second')">人员管理
										</el-button>
										<el-button size="mini" type="text" @click="meetingConfig(scope.row)">视频配置
										</el-button> -->
									</div>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</el-row>
				<el-row :gutter="24">
					<Pagination customClass="alone" :total="total" @handleSizeChange="turnPage"
						@handleCurrentChange="turnPage" >
						<!--  <template v-slot:operation>
                            <div style="padding-left:25px">
                                <el-button @click="deleteAll()">批量删除</el-button>
                                <el-button @click="toggleSelection()">取消选择</el-button>
                            </div>
                        </template> -->
					</Pagination>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="测试中" class="meeting-finished" name="third">
				<div class="meeting-search">
					<el-form :inline="true" :model="meetingForm" class="demo-form-inline">
						<div class="flex align-center justify-between">
							<div class="flex align-center searchs">
								<el-form-item label="案号" style="margin-right: 50px">
									<el-input @change="monitor" v-model.trim="meetingForm.subject" clearable placeholder="请输入案号">
									</el-input>
								</el-form-item>
								<el-form-item label="会议名称" style="margin-right: 50px">
									<el-input @change="monitor" v-model.trim="meetingForm.name" clearable placeholder="请输入会议名称">
									</el-input>
								</el-form-item>
								<el-form-item class="">
									<el-button style="margin-right: 5px;" type="primary" icon="el-icon-search" @click="onSubmit">查询
									</el-button>
									<el-button style="background-color: #F2F3F7;"
										icon="el-icon-zhongzhishaixuan" :style="resetStyle()" :disabled="resetDisabled"
										@click="reset()">重置</el-button>
									<!-- style="background: #de4d2a !important"  -->
									
								</el-form-item>
							</div>
							<!-- el-form-right-1 -->
							<!-- <div class="flex align-center">
								<el-form-item class="">
									<el-button style="background-color: #F2F3F7;margin-right: 5px;"
										icon="el-icon-zhongzhishaixuan" :style="resetStyle()" :disabled="resetDisabled"
										@click="reset()">重置</el-button>
									<el-button type="primary" icon="el-icon-search" @click="onSubmit">查询
									</el-button>
								</el-form-item>
							</div> -->
						</div>
					</el-form>
				</div>
				<el-row class="table-meeing" :gutter="24">
					<el-table :data="tableData" size="medium" height="64.6vh" v-loading="loading">
						<!-- <el-table-column type="selection" width="50"> </el-table-column> -->
						<el-table-column align="center" prop="subject" label="案号"></el-table-column>
						<el-table-column align="center" prop="name" label="会议名称"> </el-table-column>
						<el-table-column align="center" prop="startTime" label="会议日期">
							<template slot-scope="scope">
								{{ timeConvert(scope.row.startTime) }}
							</template>
						</el-table-column>
						<el-table-column align="center" prop="sponsor" label="发起人"> </el-table-column>
						<el-table-column align="center" prop="participantNum" label="参会人数">
							<template slot-scope="scope">
								{{ scope.row.participantNum ? scope.row.participantNum : 0 }}
							</template>
						</el-table-column>
						<el-table-column align="center" label="操作列" width="250">
							<template slot-scope="scope">
								<div class="operations">
									<div>
										<el-button size="medium" type="text"
											@click="openPersonManagers(scope.row.id, scope.row.name, 0, 'third',scope.row)">
											进入会议
										</el-button>

										<router-link :to="{
										    path: '/liveBroadcast',
										    query: { id: scope.row.id, name: scope.row.name,tab:'third' }
										}">会议直播</router-link>
										<el-tooltip class="item" effect="dark" content="视频配置" placement="top">
											<div class="el-icon-peizhi" style="font-size: 16px;color: #2766FF;margin-right: 5px;margin-left: 5px;"
												@click="meetingConfig(scope.row)">
										
											</div>
										</el-tooltip>
										<el-tooltip class="item" effect="dark" content="停止测试" placement="top">
											<div class="el-icon-a-tingzhiceshi1x"
												style="font-size: 16px;color: #2766FF;margin-right: 5px;margin-left: 5px;"
												@click="testMeeting(scope.row.id, 'end')">

											</div>
										</el-tooltip>
										<!-- <el-button size="mini" type="text" @click="endMeeting(scope.row.id)"></el-button> -->

										<!-- <el-dropdown trigger="click">
											<span class="el-dropdown-link">

												<i class="el-icon-arrow-down el-icon--right" style="font-size: 14px;"></i> </span>
											<el-dropdown-menu slot="dropdown">

												<el-dropdown-item class="el-droplink">
													<el-button style="color: #282D30;" icon="el-icon-renyuan" size="medium" type="text"
														@click="openPersonManager(scope.row.id, scope.row.name, 1, 'third')">人员管理</el-button>
												</el-dropdown-item>
												<el-dropdown-item class="el-droplink">
													<el-button style="color: #282D30;" icon="el-icon-peizhi" size="medium" type="text"
														@click="meetingConfig(scope.row)">视频配置
													</el-button>
												</el-dropdown-item>
											</el-dropdown-menu>
										</el-dropdown> -->
									</div>


									<!-- <div>
										<el-button size="mini" type="text" @click="enterMeeting(scope.row)">进入会议
										</el-button>
										<el-button size="mini" type="text" @click="testMeeting(scope.row.id, 'end')">
											停止测试
										</el-button>
										<router-link :to="{
										    path: '/liveBroadcast',
										    query: { id: scope.row.id, name: scope.row.name,activeName:activeName }
										}">会议直播</router-link>
									</div> -->
									<!-- <div>
										<el-button size="mini" type="text"
											@click="openPersonManager(scope.row.id, scope.row.name, 1, 'third')">人员管理
										</el-button>
										<el-button size="mini" type="text" @click="meetingConfig(scope.row)">视频配置
										</el-button>
									</div> -->
								</div>
							</template>
						</el-table-column>
					</el-table>
				</el-row>
				<el-row :gutter="24">
					<Pagination customClass="alone" :total="total" @handleSizeChange="turnPage"
						@handleCurrentChange="turnPage">
						<!--  <template v-slot:operation>
                            <div style="padding-left:25px">
                                <el-button @click="deleteAll()">批量删除</el-button>
                                <el-button @click="toggleSelection()">取消选择</el-button>
                            </div>
                        </template> -->
					</Pagination>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="已结束" class="meeting-finished" name="fourth">
				<div class="meeting-search">
					<el-form :inline="true" :model="meetingForm" class="demo-form-inline">
						<div class="flex align-center justify-between">
							<div class="flex align-center searchs">
								<el-form-item label="案号" style="margin-right: 50px">
									<el-input @change="monitor" v-model.trim="meetingForm.subject" clearable placeholder="请输入案号">
									</el-input>
								</el-form-item>
								<el-form-item label="会议名称" style="margin-right: 50px">
									<el-input @change="monitor" v-model.trim="meetingForm.name" clearable placeholder="请输入会议名称">
									</el-input>
								</el-form-item>
								<el-form-item class="">
									<el-button style="margin-right: 5px;" type="primary" icon="el-icon-search" @click="onSubmit">查询
									</el-button>
									<el-button style="background-color: #F2F3F7;"
										icon="el-icon-zhongzhishaixuan" :style="resetStyle()" :disabled="resetDisabled"
										@click="reset()">重置</el-button>
									<!-- style="background: #de4d2a !important"  -->
									
								</el-form-item>
							</div>
								<!-- el-form-right-1 -->
						<!-- 	<div class="flex align-center">
							
								
							</div> -->
						</div>
					</el-form>
				</div>
				<el-row class="table-meeing" :gutter="24">
					<el-table :data="tableData" size="medium" height="64.6vh" v-loading="loading">
						<!-- <el-table-column type="selection" width="50"> </el-table-column> -->
						<el-table-column align="center" prop="subject" label="案号"></el-table-column>
						<el-table-column align="center" prop="name" label="会议名称"> </el-table-column>
						<el-table-column align="center" prop="startTime" label="会议日期">
							<template slot-scope="scope">
								{{ timeConvert(scope.row.startTime) }}
							</template>
						</el-table-column>
						<el-table-column align="center" prop="sponsor" label="发起人"> </el-table-column>
						<el-table-column align="center" prop="participantNum" label="参会人数">
							<template slot-scope="scope">
								{{ scope.row.participantNum ? scope.row.participantNum : 0 }}
							</template>
						</el-table-column>
						<el-table-column align="center" label="操作列" width="250">
							<template slot-scope="scope">
								<div class="operations">
									<div>
										<el-button size="medium" type="text"
											@click="openPersonManagers(scope.row.id, scope.row.name, 0, 'fourth',scope.row)">
											进入会议
										</el-button>

										<router-link :to="{
										    path: '/liveBroadcast',
										    query: { id: scope.row.id, name: scope.row.name,tab:'fourth' }
										}">会议直播</router-link>
										<!-- <el-button size="18px" icon="el-icon-renyuan" type="text"
											@click="openPersonManager(scope.row.id, scope.row.name, 1, 'fourth')">
										</el-button> -->
										<el-tooltip class="item" effect="dark" content="视频配置" placement="top">
											<div class="el-icon-peizhi" style="font-size: 16px;color: #2766FF;margin-right: 5px;margin-left: 5px;cursor: pointer;"
												@click="meetingConfig(scope.row)">
										
											</div>
										</el-tooltip>
										<el-tooltip class="item" effect="dark" content="重开会议" placement="top">
											<div class="el-icon-zhongzhishaixuan" style="font-size: 16px;color: #2766FF;margin-right: 5px;margin-left: 5px;cursor: pointer;"
												@click="meetingRestart(scope.row.id)">
										
											</div>
										</el-tooltip>
										<!-- <el-button size="18px" icon="el-icon-peizhi" type="text"
											@click="meetingConfig(scope.row)">
										</el-button> -->
										<!-- <el-tooltip class="item" effect="dark" content="停止测试" placement="top">
											<div class="el-icon-edit-outline" style="font-size: 16px;color: #2766FF;"
												@click="testMeeting(scope.row.id, 'end')">
									
											</div>
										</el-tooltip> -->
										<!-- <el-button size="mini" type="text" @click="endMeeting(scope.row.id)"></el-button> -->
										<!-- <el-dropdown>
											<span class="el-dropdown-link">
									
												<i class="el-icon-arrow-down el-icon--right"
													style="font-size: 14px;"></i> </span>
											<el-dropdown-menu slot="dropdown">
									
												<el-dropdown-item class="el-droplink">
													<el-button icon="el-icon-renyuan" size="small" type="text"
														@click="openPersonManager(scope.row.id, scope.row.name, 1, 'third')">人员管理
													</el-button>
												</el-dropdown-item>
												<el-dropdown-item class="el-droplink">
													<el-button icon="el-icon-shezhi" size="small" type="text"
														@click="meetingConfig(scope.row)">视频配置
													</el-button>
												</el-dropdown-item>
											</el-dropdown-menu>
										</el-dropdown> -->
									</div>
								</div>

								<!-- <div class="operations">
									<div>
										<el-button icon="el-icon-renyuan" size="mini" type="text"
											@click="openPersonManager(scope.row.id, scope.row.name, 0, 'fourth')">人员管理
										</el-button>
										<el-button size="mini" type="text" @click="meetingConfig(scope.row)">视频配置
										</el-button>
										<el-button size="mini" type="text" @click="openPersonManagers(scope.row.id, scope.row.name, 0, '',scope.row)">进入会议
										</el-button>
									</div>
									<div>
										<router-link :to="{
										    path: '/liveBroadcast',
										    query: { id: scope.row.id, name: scope.row.name }
										}">会议直播</router-link>
									</div>
								</div> -->
							</template>
						</el-table-column>
					</el-table>
				</el-row>
				<el-row :gutter="24">
					<Pagination customClass="alone" :total="total" @handleSizeChange="turnPage"
						@handleCurrentChange="turnPage">
						<!--  <template v-slot:operation>
                            <div style="padding-left:25px">
                                <el-button @click="deleteAll()">批量删除</el-button>
                                <el-button @click="toggleSelection()">取消选择</el-button>
                            </div>
                        </template> -->
					</Pagination>
				</el-row>
			</el-tab-pane>
		</el-tabs>
		<!--  <div class="tag-download">
            <a href="javascript:;" class="know">债权人会议须知</a>
        </div> -->
	</div>
</template>

<script>
	import Pagination from '@/components/Pagination';
	import {
		deleteMeeting,
		beginMeeting,
		restartMeeting,
		testMeeting,
		endMeeting
	} from '@/serve/meeting';
	import moment from 'moment';
	import bus from '@/utils/bus.js';

	export default {
		components: {
			Pagination
		},
		props: {
			tableData: Array,
			meetingForm: Object,
			loading: Boolean,
			total: Number
		},
		created() {
			this.activeName = this.$route.query.tab ? this.$route.query.tab : 'first';
		},
		mounted() {
			this.toggleSwitch({
				name: this.activeName
			});
		},
		data() {
			return {
				activeName: 'second',
				liveUrl: '',
				videoDialogVisible: false,
				multipleSelection: [],
				meetingIds: [],
				resetDisabled: true,
				visibleChange: false,
			};
		},
		methods: {
			removeImage(e) {
				this.tableData[e].visibleChange = true;
				console.log("进入e:", this.tableData[e].visibleChange)
			},
			getList() {
				console.log("进入:")
				for (let i in this.tableData) {
					this.tableData[i].visibleChange = false;
				}
			},
			visibleChanges(e) {
				console.log("进入visibleChange:", e)
			},
			toggleVisible() {
				this.videoDialogVisible = !this.videoDialogVisible;
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
				this.meetingIds = this.multipleSelection.map((item) => item.id);
			},
			// 翻页
			turnPage(attr, val) {
				console.debug(attr, val);
				this.meetingForm[attr] = val;
				this.$emit('search', this.meetingForm);
			},
			// 时间格式化
			timeConvert(timestamp) {
				return moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
			},
			toggleSwitch(tab) {
				this.visibleChange = false;
				// 未开始
				if (tab.name == 'first') {
					this.$emit('toggle', 'notStart');
				} else if (tab.name == 'second') {
					// 已开始
					this.$emit('toggle', 'began');
				} else if (tab.name == 'third') {
					// 测试中
					this.$emit('toggle', 'test');
				} else {
					// 已结束
					this.$emit('toggle', 'ended');
				}
			},
			// 批量删除会议
			deleteAll() {
				if (!this.meetingIds.length) {
					return this.$message.warning('请先选中会议');
				}
				this.deleteMeeting(...this.meetingIds);
			},
			toggleSelection() {
				this.$refs.multipleTable.clearSelection();
			},
			// 搜索
			onSubmit() {
				this.meetingForm.page = 0;
				console.log("this.meetingForm.name", this.meetingForm)
				this.$emit('search', this.meetingForm);
			},
			openPersonManager(id, name, num, tab) {
				console.log("id, name, num, tab",num);
				this.$router.push({
					path: '/personManager',
					query: {
						num,
						id,
						name,
						tab
					}
				});
			},
			openPersonManagers(id, name, num, tab, row, isShow = true) {
				// this.setDialogVisible('goIntoDialogVisible', false, row);
				// this.$emit('enter', row, isShow);
				console.log("meetingInfo:")
				this.$router.push({
					path: '/enterMeeting',
					query: {
						num,
						id,
						name,
						tab,
						row,
						isShow
					}
				});
			},
			// 删除会议
			deleteMeeting(...ids) {
				let meetingIds = ids;
				this.$confirm('此操作将永久删除该会议, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					customClass: 'del-model',
					type: 'warning'
				}).then(() => {
					deleteMeeting({
							meetingIds
						})
						.then(() => {
							this.$message.success('删除成功');
							this.$emit('refreshList');
						})
						.catch((err) => {
							this.$message.error('删除失败');
						});
				});
			},
			setDialogVisible(type, flag = false, row) {
				this.$emit('sure', type, flag, row);
			},
			// 编辑会议
			editMeeting(row) {
				this.setDialogVisible('newDialogVisible', true, row);
				this.$emit('edit', row);
			},
			// 新建会议
			addCreateMeeting(row = {}) {
				this.setDialogVisible('newDialogVisible', false, row);
				this.$emit('add');
			},
			// 视频配置
			meetingConfig(row) {
				console.log("row",row)
				this.setDialogVisible('lineDialogVisible', false, row);
				this.$emit('config', row);
			},
			// 会议直播
			/* liveMeeting(url, name, id) {
			    this.$router.push({
			        path: '/liveBroadcast',
			        query: {
			            url,
			            name,
			            id
			        }
			    });
			}, */
			// 进入会议
			enterMeeting(row, isShow = true) {
				this.setDialogVisible('goIntoDialogVisible', false, row);
				this.$emit('enter', row, isShow);
			},
			// 测试会议
			testMeeting(id, flag) {
				let msg = flag == 'start' ? '开始' : '停止';
				this.$confirm(`此操作将对会议${msg}测试, 是否继续?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					customClass: 'del-model',
					type: 'warning'
				}).then(() => {
					testMeeting(id)
						.then(() => {
							this.$emit('refreshList');
							this.$message.success(`测试会议已${msg}`);
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						});
				});
			},
			// 停止会议
			endMeeting(id) {
				this.$confirm('此操作将结束会议, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						customClass: 'del-model',
						type: 'warning'
					})
					.then(() => {
						endMeeting(id)
							.then(() => {
								this.$emit('refreshList');
								this.$message.success('结束会议成功');
							})
							.catch((err) => {
								this.$message.error(err.data.message);
							});
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 开始会议
			beginMeeting(id) {
				this.$confirm('此操作将开启正式会议, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					customClass: 'del-model',
					type: 'warning'
				}).then(() => {
					beginMeeting(id)
						.then(() => {
							this.$emit('refreshList');
							this.$message.success('开始会议成功');
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						});
				});
			},
			//重开会议
			meetingRestart(id) {
				this.$confirm('此操作将重新开启已结束的会议, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					customClass: 'del-model',
					type: 'warning'
				}).then(() => {
					restartMeeting(id)
						.then(() => {
							this.$emit('refreshList');
							this.$message.success('开始会议成功');
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						});
				});
			},
			reset() {
				this.meetingForm.subject = '';
				this.meetingForm.name = '';
				this.resetDisabled = true;
			},
			resetStyle() {
				let type = false;
				if (this.meetingForm.subject != '' || (this.meetingForm.name != undefined && this.meetingForm.name !=
						'')) {
					type = true;
				}
				let color = type ? "#282D30" : "rgba(0,0,0,0.4)"
				return {
					color: color
				}
			},
			monitor(e) {
				if (this.meetingForm.subject != '' || this.meetingForm.name != '') {
					this.resetDisabled = false;
				} else {
					this.resetDisabled = true;
				}

			}
		}
	};
</script>
<style lang="scss">
	.el-dropdown-menu__item .el-button--text{
		color: #282D30;
	}
	.el-dropdown-menu__item .el-button--text:hover{
		color: #2766FF;
	}
	.searchs .el-input__inner{
		background-color: #F3F4F6;
		border: 0px;
		border-radius: 3px;
	}
	.del-model {
		.el-message-box__btns {
			.el-button:nth-child(1) {
				float: right;
			}

			.el-button:nth-child(2) {
				margin-right: 10px;
				// background-color: #de4d2a;
				border-color: #ffffff;
			}
		}
	}
</style>
<style scoped lang="scss">
	.select ::v-deep .el-tooltip__trigger {
		.el-icon--right {
			transition: all 0.2s ease;
		}
	}

	.select ::v-deep .el-tooltip__trigger[aria-describedby] {
		.el-dropdown-link .el-icon {
			transform: rotate(180deg);
		}
	}

	.visibleChange {
		transform: rotate(180deg);
		transition: all 0.5s
	}

	.wrapper {
		position: relative;

		::v-deep .el-form {
			position: relative;
		}

		.el-form-right-1 {
			position: absolute;
			right: 6%;
		}

		.el-form-right-2 {
			position: absolute;
			right: 3%;
		}

		.el-form-right-1 button {
			// background: #de4d2a;
		}

		.el-form-right-2 button {
			// background: #de4d2a;
		}

		.el-form-right-1 {
			margin-right: 100px;
		}

		.tag-download {
			position: absolute;
			right: 2%;
			top: 2%;
			font-size: 15px;
			text-decoration: underline;
		}

		.meeting-list ::v-deep .el-tab-pane:nth-child(1),
		.meeting-list ::v-deep .el-tab-pane:nth-child(2),
		.meeting-list ::v-deep .el-tab-pane:nth-child(3) {
			margin: -15px;
		}

		.meeting-search-text {
			font-size: 16px;
			font-family: HarmonyOS Sans SC-Medium, HarmonyOS Sans SC;
			font-weight: 600;
			color: #000000;
			line-height: 16px;
			background-color: #FFFFFF;
		}

		.meeting-search {
			width: 100%;
			background: #FFFFFF;
			padding-top: 30px;
			padding-left: 16px;
			box-sizing: border-box;

			.meeting-search-button {
				margin-left: 15px;
			}

			.meeting-test-number {
				padding-bottom: 15px;
			}
		}

		.table-meeing {
			// margin-top: 20px;
			box-sizing: border-box;
			padding: 0 10px;

			.operations {
				display: flex;
				align-items: center;
				justify-content: center;
				text-align: left;
				// white-space: break-spaces;
				// word-break: break-all;
				// display: flex;

				.el-button {
					white-space: nowrap;
				}

				a {
					color: #2766FF;
					font-size: 14px;
					margin-right: 10px;

					&:hover {
						border-bottom: 1px solid #2766FF;
					}
				}
			}

			.el-button {
				color: #2766FF;
				text-align: justify;
				white-space: break-spaces;
				word-break: break-all;
				margin-right: 15px;
				margin-left: 0;
			}

			.el-button ::v-deep span:hover {
				border-bottom: 1px solid #2766FF;
			}

			.block {
				text-align: right;
				margin-right: 50px;
			}

			::v-deep .el-link--inner {
				padding: 0 8px;
				box-sizing: border-box;
			}
		}

		.el-table ::v-deep .is-leaf {
			// background: #c22929 !important;
			//  background: -webkit-linear-gradient(top, #cc0001 , #de4d2a, #f17b2e) !important;
			// background: -webkit-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
			// background: -moz-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
			// background: -o-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
			// background: -ms-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
			// background: linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
			// background: #fafbfd;
			// color: rgba(25, 30, 36, 0.6);
		}

		.meeting-finished {
			margin: -15px;
		}

		.el-dropdown {
			font-size: 12px;
			color: #2766FF;

			.el-dropdown-item {
				a {
					color: #2766FF;
					font-size: 12px;

					&:hover {
						border-bottom: 1px solid #2766FF;
					}
				}
			}

			&:hover {
				cursor: pointer;

				i {}
			}
		}
	}

	.router-link-active {
		text-decoration: none; //去除默认样式
		color: #2766FF; //高亮的颜色
	}

	a {
		text-decoration: none;
		color: #2766FF;
	}
</style>
